import React,{useState,useEffect,useContext} from 'react';
import {Box,LinearProgress,//IconButton,Typography
    IconButton,Tooltip,FormControl,InputLabel,Select,
    MenuItem,TextField,FormControlLabel,Checkbox} from "@material-ui/core";
import { authUser } from '../funciones/AuthUser'
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import axios from 'axios';
import qs from 'qs';
import {llamaApiCargaToken,llamadaApiToken,ErrorGeneral } from '../funciones/ClienteAxios';
import Graficas from './GraficasRegion';
import CardTotal from './CardTotal';

import TablaMun from './TablaTarea';
import GraficaPolar from './GraficaPolar';
import IntervaloSelect from './IntervaloTabla';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import TablaTarea from './TablaTarea';
import NavBar from './NavBar';
const arreColores=["#038545", "#EF8012", "#347AF4", "#FFC107", "#119A4F", "#B406D8", "#FFA318", "#DC4A3D", "#32CA81", 
"#F9B546", "#ED0808", "#0097A7", "#880E4F", "#4BAC7D", "#C52363", "#F57F06", "#7C594C", "#DBE772"]

const Tareas = () => {
    const history = useHistory();    
    const source = axios.CancelToken.source();
    const auxId =localStorage.getItem('UsuId') ;  
    const nvl= localStorage.getItem('Tipo');          
    const usu= localStorage.getItem('UsuarioNom');   
    const auxDispV =localStorage.getItem('Dispvo') && localStorage.getItem('Dispvo').length >= 12 ? localStorage.getItem('Dispvo') :'w8rf51v21dsd2cs'      
    const {usuario,guardarUsuario}= useContext(AuthContext);
    const {generales,guardarGenerales}= useContext(GeneralesContext);    
    const [listTotl, setListTotl] = useState([])                   
    const [listSolicitud, setListSolicitud] = useState([])                
    const [espera, setEspera] = useState(false)              
    const [registro, setRegistro] = useState({Id:0,Num:0})      
    const [regMun, setRegMun] = useState([])            
    const [listAvMun, setListAvMun] = useState([])            
    const [fSelect, setFSelect] = useState({inicio:new Date("2025-08-03T00:00:00"),final:new Date()});
    const [buscar, setBuscar] = useState(false);
    const [tipoTabla, setTipoTabla] = useState(1);

    const reiniciar=()=>{        
        setListTotl([])                                   
        setBuscar(!buscar);
    }

    useEffect(()=>{             
        const autenticado = authUser();
        if(!autenticado)
        {   localStorage.clear();
            history.push("/");
            guardarUsuario([])
        }
        else
        {   if (usuario.length===0) 
            {   guardarUsuario({Nombre:usu,nivel:nvl});                                                           
            }                       
           
            guardarGenerales({...generales,Titulo:'Expedientes'})      
            llenaTotales()            
       
        }
        
        return ()=> {
            source.cancel();
        }      
    //la siguiente linea puede generar errores o no en el useEffect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[buscar]);

    const llenaTotales = () => {
        const fInicio=moment(fSelect.inicio).format("YYYY-MM-DD");
        const fFinal=moment(fSelect.final).format("YYYY-MM-DD");         
        const data = qs.stringify({
            Usuario: auxId,                                
            FIni:fInicio+'T00:00:00',
            FFin:fFinal+'T23:59:59',
            idDispositivo: auxDispV,
        });
        const url = "tarea-list";

        function respuesta(response) {
            if (response) 
            {                 
                setListSolicitud(response )               
            }
        }
    
        llamaApiCargaToken(data, url, respuesta, ErrorGeneral,setEspera, history, source);
    };

    return (
    <div style={{display:"flex"}}>
      

        
        <Box>
        <Box display={'flex'} pb={1}>
            <Box >
                <IconButton color="primary"  aria-label="add circle" 
                component="span" onClick={()=>setBuscar(!buscar)}>
                    <Tooltip title="Buscar">
                        <SearchIcon/>
                    </Tooltip>
                </IconButton>                                                                                                                              
            </Box>
          
            <Box >
                <IntervaloSelect  fSelect={fSelect}  setFSelect={setFSelect}/>
            </Box>
            {/* listAv.length !== 0 ?
                <CardTotal valor={listAv}  />
            :null */
            }
        </Box>
        
            <Box display={"flex"} flexDirection={"row"} >
               
                { listSolicitud.length !== 0?
                    <TablaTarea  listSolicitud={listSolicitud} registro={regMun}  
                        setRegistro={setRegMun}                         
                    />       
                :null}
                {regMun.length!==0 ?<Box width={"27rem"}><NavBar regMun={regMun} /> </Box>:null}
                { /*  listAv.length !==0  ?
                    <GraficaPolar valor={listAv} />
                :null   */}
            </Box>            
        </Box>
        
    </div>
  )
}

export default Tareas